module.exports = __webpack_public_path__ + "img/401.34f4286d.svg";